import { useMemo } from "react";
import { DateTime } from "luxon";
import { GradualSpacing } from '../../../effects/GradualSpacing';

export interface SectionHeaderProps {
    title: string
    isShowDate: boolean,
    animated?: boolean,
    animationOffset?: number,
    style?: object,
}

function SectionHeader(props: SectionHeaderProps) {
    const {
        title,
        isShowDate,
        animated = false,
        animationOffset = 0,
        style = {},
    } = props;

    const date = useMemo(() => {
        if (isShowDate) {
            const now = DateTime.now();
            return now.toFormat("LLL dd yyyy").toUpperCase();
        }

        return null;
    }, [isShowDate]);

    return (
        <div style={{
            position: 'absolute',
            padding: '2.6vh', // 50px
            textTransform: 'uppercase',
            fontFamily: 'HelveticaNowDisplay',
            fontWeight: '500',
            lineHeight: '1.83vh', // 35.20px
            letterSpacing: '0.03vh', // 0.64px
            fontSize: '1.67vh', // 32px
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100vw',
            ...style,
        }}>
            <p>{animated ? (<GradualSpacing text={title} offset={animationOffset} />) : title}</p>
            {date ? <p>{animated ? (<GradualSpacing text={date} offset={animationOffset} />) : date}</p> : null}
        </div>
    )
}

export default SectionHeader;
